import { IconCircleCheck } from '@calendly/ui/components/glyphs/IconCircleCheck'
import { UiIcon } from '@calendly/ui/components/ui-icon'
const colorTextSuccess = 'var(--colorTextSuccess, var(--coreColorGreen800))'

import { useI18n } from 'locales'

import { SuccessBanner } from './styles'

export const PhoneVerificationSuccessBanner = () => {
  const { i18n } = useI18n()

  return (
    <SuccessBanner>
      <UiIcon icon={IconCircleCheck} size="small" color={colorTextSuccess} />
      {i18n.t('booking.phone_verification.scheduled_success')}
    </SuccessBanner>
  )
}
